import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      d: "M17.526 4.418a.75.75 0 0 1 1.056 1.056l-.052.056-10 10a.75.75 0 0 1-1.004.052l-.056-.052-5-5-.052-.056a.75.75 0 0 1 1.056-1.056l.056.052L8 13.94l9.47-9.47.056-.052Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "check"}) } }